import React from 'react';
import { Styles } from './styles';

interface LoadingProps {
  showOverlay?: boolean;
}

const Loading = ({ showOverlay = true }: LoadingProps) => {
  return (
    <Styles.LoadingContainer showOverlay={showOverlay}>
      <Styles.Spinner />
    </Styles.LoadingContainer>
  );
};

export default Loading;
